import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { EPaymentStatus } from 'src/type';

import { getCurrencyFromSettings } from 'src/utils';

import { useAppContext } from 'src/context/useAppContext';
import { useCustomSearchParams, useWidgetHelp } from 'src/hook';

import { selectPayment } from 'src/store/slice/payment/state';

import InvoiceDefault from './InvoiceDefault';
import InvoiceOpenDeposit from './InvoiceOpenDeposit';

import './currency-price.scss';

const CurrencyPrice: React.FC = (): JSX.Element => {
  const { currency, setCurrency } = useAppContext();
  const { isDefaultInvoice, isOpenDepositInvoice } = useWidgetHelp();
  const { queryCurrency, queryNetwork } = useCustomSearchParams();

  const payment = useSelector(selectPayment);

  const { currency_settings, currency_id, currency_network, client_status } = payment || {
    currency_settings: [],
    currency_id: '',
    currency_network: '',
  };

  /**
   * useEffect for understed if the selected currency matches the invoice currency and set default currency in to dropdown
   */
  useEffect(() => {
    if (!currency.currency_id && payment && client_status !== EPaymentStatus.Completed) {
      const defaultCurrency = currency_settings[0];

      const btc = getCurrencyFromSettings(currency_settings, 'BTC', 'BITCOIN');
      const createdInvoiceCurrency = getCurrencyFromSettings(
        currency_settings,
        queryCurrency || currency_id,
        queryNetwork || currency_network
      );

      const selectedCurrency = createdInvoiceCurrency || btc || defaultCurrency;

      setCurrency({ currency_id: selectedCurrency.currency_id, network: selectedCurrency.network });
    }
  }, [payment]);

  return (
    <>
      <div className="currency-price">
        {isDefaultInvoice && <InvoiceDefault />}
        {isOpenDepositInvoice && <InvoiceOpenDeposit />}
      </div>
    </>
  );
};

export default CurrencyPrice;
